import { useAuth } from "@/context/auth-provider";
import { StatsigProvider, useClientAsyncInit } from "@statsig/react-bindings";
import { StatsigSessionReplayPlugin } from "@statsig/session-replay";
import { StatsigAutoCapturePlugin } from "@statsig/web-analytics";
import React from "react";

interface StatsigWrapperProps {
  children: React.ReactNode;
}

export const StatsigWrapper: React.FC<StatsigWrapperProps> = ({ children }) => {
  const { user } = useAuth();

  // Use user ID if available, otherwise fall back to 'a-user'
  const userID = user?.id?.toString() || user?.username || "a-user";

  const statsigClientKey = process.env.GATSBY_STATSIG_CLIENT_KEY;
  const isProduction = process.env.NODE_ENV === "production";

  // Disable Statsig in production for privacy reasons
  // Session replay and analytics tracking of financial data raises privacy/compliance concerns
  if (!statsigClientKey || isProduction) {
    if (isProduction) {
      console.info("Statsig disabled in production for user privacy.");
    } else {
      console.warn("GATSBY_STATSIG_CLIENT_KEY is not set. Statsig will not be initialized.");
    }
    return <>{children}</>;
  }

  const { client } = useClientAsyncInit(
    statsigClientKey,
    { userID },
    {
      plugins: [
        new StatsigAutoCapturePlugin(),
        new StatsigSessionReplayPlugin(),
      ],
    }
  );

  return (
    <StatsigProvider client={client} loadingComponent={<div>Loading...</div>}>
      {children}
    </StatsigProvider>
  );
};
